/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Setting_DescriptionInputs */

const fr_extra_session_setting_description = /** @type {(inputs: Extra_Session_Setting_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de séances achetées qu'un adhérent peut utiliser en plus de son quota, par semaine (ou par mois pour un crédit mensuel). 0 désactive l'achat. Une séance achetée puis annulée reste en réserve pour plus tard. Le tarif est celui du prix Stripe marqué option = extra_session.`)
};

/**

* @param {Extra_Session_Setting_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_setting_description = /** @type {((inputs?: Extra_Session_Setting_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Setting_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_setting_description(inputs)
});